import { render, staticRenderFns } from "./UpdateKnowledgePage.vue?vue&type=template&id=961d3464&scoped=true"
import script from "./UpdateKnowledgePage.vue?vue&type=script&lang=js"
export * from "./UpdateKnowledgePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "961d3464",
  null
  
)

export default component.exports